<template>
  <v-app>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="4"
      >
        <base-material-card color="primary">
          <template v-slot:heading>
            <v-row>
              <v-col
                cols="12"
                md="9"
              >
                <div
                  class="text-h3 font-weight-light"
                >
                  Recuperar Contraseña
                </div>
                <div
                  class="text-subtitle-1 font-weight-light"
                >
                  Ingrese su correo electronico
                </div>
              </v-col>
              <v-col
                cols="1"
                md="1"
              >
                <v-spacer />
                <v-btn
                  icon
                  outlined
                  fab
                  to="/login"
                >
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <v-container class="py-0">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="login"
            >
              <v-text-field
                v-model="credentials.email"
                label="Correo Electronico"
                prepend-icon="mdi-at"
                type="email"
              />
              <v-row
                align="center"
                justify="center"
                style="margin-top:30px"
              >
                <v-btn
                  color="primary"
                  class="mr-0"
                  :disabled="!valid"
                  type="submit"
                  @click="recuperar()"
                >
                  Recuperar
                </v-btn>
              </v-row>
              <br>
              <v-overlay :value="overlay">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="64"
                />
              </v-overlay>
            </v-form>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'Auth',
    data: () => ({
      expandOnHover: false,
      credentials: {},
      valid: true,
      overlay: false,
      loading: false,
      rules: {
        username: [
          v => !!v || 'El usuario es requerido',
          v => (v && v.length > 3) || 'Mínimo 3 caracteres',
          v =>
            /^[a-z0-9_]+$/.test(v) ||
            'Solo puede estar comprendido de caracteres alfanuméricos',
        ],
        password: [
          v => !!v || 'La contraseña es requerida',
          v => (v && v.length >= 5) || 'Debe tener por lo menos 5 digitos',
        ],
      },
    }),
    methods: {
      recuperar () {
        this.overlay = true
        delete axios.defaults.headers.common.Authorization
        axios.post(window.location.protocol + '//' + window.location.hostname + ':85/inventario/' + 'dj-rest-auth/password/reset/', this.credentials)
          .then(res => {
            this.overlay = false
            this.$swal({
              text: 'Correo enviado con el link de recuperacion',
              showConfirmButton: true,
              showCloseButton: false,
              timer: 30000,
              icon: 'success',
            })
            this.$router.push({ name: 'login' })
          })
          .catch(err => {
            console.log(err)
            this.$swal({
              text: 'Correo equivocado',
              showConfirmButton: false,
              showCloseButton: false,
              timer: 3000,
              icon: 'warning',
            })
          })
      },
    },
  }
</script>
<style scoped>
  h2 {
      position: relative;
      font-size: 30px;
      z-index: 1;
      overflow: hidden;
      text-align: center;
  }
  h2:before, h2:after {
      position: absolute;
      top: 51%;
      overflow: hidden;
      width: 50%;
      height: 1px;
      content: '\a0';
      background-color: rgb(111, 106, 106);
  }
  h2:before {
      margin-left: -50%;
      text-align: right;
  }
</style>
